<template>
  <b-modal ref="modal" header-bg-variant="primary" header-class="text-white">
    <template #modal-header>
      <h3>
        <i class="ifr if-cancel text-danger mr-3"></i
        >{{ $t("errors.unexpected.headline") }}
      </h3>
    </template>
    <b-row>
      <b-col cols="12">
        <p>
          {{ $t("errors.unexpected.text") }}
        </p>
      </b-col>
    </b-row>
    <template #modal-footer>
      <b-row>
        <b-col cols="12" class="text-center">
          <button class="btn btn-secondary" @click="$refs.modal.hide()">
            {{ $t("actions.close") }}
          </button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
  export default {
    name: "TokenInvalidModal",
    beforeRouteLeave(to, from, next) {
      this.$refs.modal.hide();
      next();
    },
    methods: {
      show() {
        this.$refs.modal.show();
      },
    },
  };
</script>

<style>
</style>
